import type { ReactNode } from 'react'
import { CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { ReportCountBadge as CountBadge } from '../-helpers'

type SectionCardHeaderProps = {
  title: ReactNode
  description?: ReactNode
  /** A count label shown as a badge when set. */
  count?: ReactNode
  action?: ReactNode
}

export function SectionCardHeader({ title, description, count, action }: SectionCardHeaderProps) {
  return (
    <CardHeader className="gap-4 md:flex md:flex-row md:items-start md:justify-between">
      <div className="space-y-1.5">
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {action}
        {count ? <CountBadge>{count}</CountBadge> : null}
      </div>
    </CardHeader>
  )
}
